import {Link} from "#/src/components/Link";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import clock from "#/src/assets/svg/clock.svg";
import {TimeDisplay} from "#/src/components/TimeDisplay";
import chat from "#/src/assets/svg/chat.svg";
import {Sort} from "#/src/utils/sort-utils";
import {ApiArticle, ApiArticleComment} from "#/src/definitions/ApiDefinitions";
import {getProfileUrl} from "#/src/utils/profile-url";
import styled from "@emotion/styled";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";
import React from "react";

const ArticleCard = styled(Link)`
  text-decoration: none;
`;

interface Props {
  article: ApiArticle,
  comments: ApiArticleComment[]
}

export function ArticleCommentsView({article, comments}: Props) {
  return <div className="panel-card">
    <ArticleCard href={`/blog/${article.slug}`}>
      <article className="article-short">
        <figure className="short-img">
          <img src={Attachments.getUrl(AttachmentNamespace.ARTICLE, article) + "-small"} alt={article.slug}/>
        </figure>
        <div className="short-content mt-1">
          <Link href={`/blog?category=${article.category.slug}`} className="tag-small">{article.category.name}</Link>
          <Link href={`/blog/${article.slug}`} className="short-title">{article.title}</Link>
          <div className="article-author mt-1">
            <div className="author">
              <AvatarWithFallback user={article.author} className={"avatar avatar-20"}/>
              <a href={getProfileUrl(article.author)} className="author-link">{article.author.username}</a>
            </div>
            <div className="article-date">
              <img src={clock} alt={"Data"} className={"me-2"}/>
              <span><TimeDisplay date={article.creationDate}/></span>
            </div>
          </div>
        </div>
      </article>
    </ArticleCard>
    <div className="panel-body">
      <div className="comments-title mb-3">
        <span>
          <img src={chat} alt="chat" className={"me-2"}/>
          <h6 className="text-headline d-inline">Twój komentarz</h6>
        </span>
      </div>
      {Sort.byDate(comments).map((comment: ApiArticleComment) => {
        return <div key={comment.id} className="msg">
          <div className="msg-author d-flex align-items-center justify-content-between">
            <div className="msg-author-group d-flex align-items-center gap-2">
              <div className="author">
                <AvatarWithFallback user={comment.author} className={"avatar avatar-40"}/>
                <a href={"/my-profile"} className="author-link">{comment.author.username}</a>
              </div>
              <span className="msg-date">
                <TimeDisplay date={comment.creationDate}/>
                {comment.pendingModeration && <span className={"ms-2 text-primary"}>W moderacji</span>}
              </span>
            </div>
          </div>
          <div className="msg-content">
            <p className="msg-text">{comment.message}</p>
          </div>
        </div>
      })}
    </div>
  </div>
}